export const ur = {
  // Navigation
  nav: {
    home: "ہوم",
    ourServices: "ہماری خدمات",
    aboutUs: "ہمارے بارے میں",
    ourTeam: "ہماری ٹیم",
    contactUs: "ہم سے رابطہ کریں"
  },

  // Hero Section
  hero: {
    title: "اعتماد کے ساتھ عالمی سطح پر پھیلائیں",
    subtitle: "ہم آپ کو متحدہ عرب امارات، سعودی عرب اور روس میں اپنا کاروبار قائم کرنے میں مدد کرتے ہیں۔",
    consultationTitle: "ابھی مفت مشاورت بک کریں",
    startNow: "ابھی شروع کریں",
    modalTitle: "مفت مشاورت بک کریں",
    countrySelect: "اپنا ملک منتخب کریں",
    countryPlaceholder: "ملک منتخب کریں",
    personalInfo: "ذاتی معلومات",
    firstName: "پہلا نام",
    lastName: "آخری نام",
    emailAddress: "ای میل ایڈریس",
    nationality: "قومیت",
    phoneNumber: "فون نمبر",
    servicesLabel: "وہ خدمات جو آپ چاہتے ہیں",
    serviceSelect: "خدمت منتخب کریں",
    service1: "بینک اکاؤنٹس کھولیں",
    service2: "ویزا اور امیگریشن خدمات",
    service3: "ہوٹل بکنگ",
    service4: "ہوائی جہاز کے ٹکٹ",
    service5: "ویب سائٹ ڈویلپمنٹ",
    service6: "موبائل ایپ ڈویلپمنٹ",
    submit: "جمع کریں"
  },

  // About Us Section
  aboutUs: {
    title: "ہمارے بارے میں",
    paragraph1: "اتقان بزنس سروسز متحدہ عرب امارات میں کاروباریوں اور کمپنیوں کو آسانی اور تیزی سے اپنی کمپنیاں قائم کرنے میں مدد کے لیے قائم کی گئی تھی۔ ہم مین لینڈ اور فری زون کمپنی کی تشکیل، پرو اور سرکاری خدمات، ٹیکس اور ویلیو ایڈڈ ٹیکس مشاورت، مالی بیانات، اور دستاویزات کی تصدیق سمیت خدمات کی مکمل رینج فراہم کرتے ہیں۔",
    paragraph2: "سالوں کے دوران، ہم کاروباریوں اور چھوٹے اور درمیانے کاروباروں کے لیے ایک قابل اعتماد پارٹنر بن گئے ہیں، جو متحدہ عرب امارات اور اس سے آگے ترقی کو سپورٹ کرنے والے بے عیب قانونی، مالی اور ریگولیٹری حل فراہم کرتے ہیں۔ ہمارا مشن واضح ہے: کاروبار کی ترتیب اور آپریشنز کو آسان، تیز اور قابل اعتماد بنانا — تاکہ آپ کامیابی حاصل کرنے پر توجہ مرکوز کر سکیں۔"
  },

  // Services Section
  services: {
    title: "ہماری خدمات",
    subtitle: "ہم جامع کاروباری حل فراہم کرتے ہیں",
    startingFrom: "سے شروع",
    mainlandCompany: {
      name: "مین لینڈ کمپنی کی تشکیل",
      desc: "آسانی سے اپنی مین لینڈ کمپنی قائم کریں۔ ہم تمام قانونی اقدامات سنبھالتے ہیں تاکہ آپ اپنے کاروبار کی ترقی پر توجہ مرکوز کر سکیں۔",
      price: "10,000 درہم"
    },
    freeZoneCompany: {
      name: "فری زون کمپنی کی تشکیل",
      desc: "تیزی اور کم لاگت سے اپنا فری زون کاروبار شروع کریں۔ لچکدار ملکیت اور آسان سیٹ اپ سے لطف اندوز ہوں۔",
      price: "6,000 درہم"
    },
    proServices: {
      name: "پرو اور سرکاری خدمات",
      desc: "لائسنس کی تجدید سے لے کر گولڈن ویزا تک، ہم آپ کے تمام سرکاری لین دین کو آسانی سے سنبھالتے ہیں۔"
    },
    taxConsultancy: {
      name: "ٹیکس اور ویلیو ایڈڈ ٹیکس مشاورت",
      desc: "ماہر ٹیکس اور ویلیو ایڈڈ ٹیکس رہنمائی کے ساتھ مطابقت رکھیں۔ ہم آپ کو خطرات کو کم کرنے اور کارکردگی کو زیادہ سے زیادہ بنانے میں مدد کرتے ہیں۔"
    },
    financialStatements: {
      name: "مالی بیانات",
      desc: "درست مالی رپورٹیں جو آپ کے کاروبار کو ٹریک پر رکھتی ہیں۔ ہم شفافیت اور مطابقت کو یقینی بناتے ہیں۔"
    },
    documentAttestation: {
      name: "دستاویزات کی تصدیق",
      desc: "آپ کی تمام کاروباری ضروریات کے لیے تیز اور قابل اعتماد دستاویزات کی تصدیق کی خدمات۔"
    },
    bankAccounts: {
      name: "بینک اکاؤنٹس کھولیں",
      desc: "متحدہ عرب امارات اور بین الاقوامی طور پر افراد اور کاروبار کے لیے بینک اکاؤنٹس کھولنے میں پیشہ ورانہ مدد۔"
    },
    visaServices: {
      name: "ویزا اور امیگریشن خدمات",
      desc: "سیاحتی ویزا، کاروباری ویزا اور رہائشی اجازت نامے سمیت جامع ویزا اور امیگریشن خدمات۔"
    },
    hotelBooking: {
      name: "ہوٹل بکنگ",
      desc: "مسابقتی نرخوں کے ساتھ کاروباری سفر اور تفریحی سفر کے لیے آسان ہوٹل بکنگ خدمات۔"
    },
    flightTickets: {
      name: "ہوائی جہاز کے ٹکٹ",
      desc: "دنیا بھر میں بہترین ڈیلز اور راستوں تک رسائی کے ساتھ قابل اعتماد فلائٹ بکنگ خدمات۔"
    },
    websiteDevelopment: {
      name: "ویب سائٹ ڈویلپمنٹ",
      desc: "آپ کی آن لائن موجودگی قائم کرنے اور آپ کے کاروبار کو بڑھانے کے لیے مخصوص ویب سائٹ ڈویلپمنٹ خدمات۔",
      price: "1,500 درہم"
    },
    mobileAppDevelopment: {
      name: "موبائل ایپ ڈویلپمنٹ",
      desc: "iOS اور Android پلیٹ فارمز کے لیے پیشہ ورانہ موبائل ایپلیکیشن ڈویلپمنٹ۔",
      price: "3,500 درہم"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "ہماری ٹیم",
    subtitle: "ہمارے ماہر پیشہ ور افراد سے ملاقات کریں",
    members: [
      {
        name: "انج/ہناء",
        role: "کاروبار سیٹ اپ ٹیم لیڈر"
      },
      {
        name: "انج/علی",
        role: "کاروبار سیٹ اپ ٹیم لیڈر"
      },
      {
        name: "انج/عبداللہ",
        role: "کاروبار سیٹ اپ ٹیم لیڈر"
      },
      {
        name: "انج/سارہ",
        role: "کاروبار سیٹ اپ ٹیم لیڈر"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "ہمارے گاہک کیا کہتے ہیں",
    subtitle: "مطمئن گاہکوں کی گواہیاں",
    testimonials: [
      {
        name: "جان ڈو",
        role: "سی ای او، ٹیک اسٹارٹ انک۔",
        text: "اتقان نے دبئی میں میری کمپنی کا قیام اتنا آسان اور تیز بنا دیا۔ ان کی ٹیم نے سب کچھ پیشہ ورانہ طریقے سے سنبھالا، اور میں بغیر کسی تناؤ کے اپنا کاروبار شروع کر سکا۔ فری زون سیٹ اپ صرف 3 دن میں مکمل ہوا!"
      },
      {
        name: "سمیر اسمتھ",
        role: "مارکیٹنگ مینیجر، عالمی حل",
        text: "ان کی ٹیکس مشاورت کی بدولت، اب مجھے پورا اعتماد ہے کہ میرا کاروبار مطابقت رکھتا ہے اور مالی طور پر محفوظ ہے۔ ان کی مہارت نے مجھے ہزاروں کی بچت کرائی ممکنہ جرمانوں میں۔"
      },
      {
        name: "مائیکل براؤن",
        role: "کاروبار کا مالک، ریٹیل چین",
        text: "اتقان میں پرو سروسز کی ٹیم غیر معمولی ہے۔ انہوں نے میرے تمام سرکاری لین دین کو آسانی سے سنبھالا، لائسنس کی تجدید سے لے کر ویزا کی درخواستوں تک۔ شدید سفارش کرتا ہوں!"
      },
      {
        name: "ایمران ولسن",
        role: "فری لانسر، ڈیجیٹل ایجنسی",
        text: "فری لانسر کے طور پر، مجھے دستاویزات کی تصدیق اور بینک اکاؤنٹ کھولنے میں مدد کی ضرورت تھی۔ اتقان نے سب کچھ اتنا آسان اور سستا بنا دیا۔ اب میں اپنے گاہکوں پر توجہ مرکوز کر سکتا ہوں جبکہ وہ کاغذی کارروائی سنبھالتے ہیں۔"
      },
      {
        name: "ڈیوڈ لی",
        role: "کاروباری، ای کامرس",
        text: "ان کی مالی بیانات کی خدمات بہترین ہیں۔ رپورٹیں درست اور تفصیلی ہیں اور انہوں نے مجھے اپنے کاروبار کی توسیع کے لیے فنڈنگ حاصل کرنے میں مدد کی۔ پورے عمل میں پیشہ ورانہ خدمت!"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "ہمارے شراکت دار",
    subtitle: "اہم تنظیموں کی طرف سے قابل اعتماد"
  },

  // Contact Us Section
  contactUs: {
    title: "ہم سے رابطہ کریں",
    subtitle: "ہم سے رابطہ کریں",
    getInTouch: "رابطہ کریں",
    contactInfo: "رابطے کی معلومات",
    sendMessage: "پیغام بھیجیں",
    name: "نام",
    email: "ای میل",
    subject: "موضوع",
    message: "پیغام",
    fullName: "پورا نام",
    fullNamePlaceholder: "اپنا نام درج کریں",
    emailAddress: "ای میل ایڈریس",
    emailPlaceholder: "اپنا ای میل درج کریں",
    phoneNumber: "فون نمبر",
    phonePlaceholder: "فون نمبر",
    activity: "سرگرمی",
    activityPlaceholder: "اپنی سرگرمی درج کریں",
    submit: "جمع کریں"
  },

  // Footer
  footer: {
    allRightsReserved: "تمام حقوق محفوظ ہیں",
    privacyPolicy: "رازداری کی پالیسی",
    termsOfService: "سروس کی شرائط",
    description: "اتقان بزنس سروسز – کاروبار کی ترتیب کو آسان اور تیز بنانا۔",
    location: "مقام: دبئی، متحدہ عرب امارات",
    phone: "📞 فون: +971 XXX XXX XXX",
    email: "✉️ ای میل: info@itqan.com",
    copyright: "© 2025 اتقان بزنس سروسز۔ تمام حقوق محفوظ ہیں۔",
    companyProfile: "کمپنی پروفائل"
  },

  // Ad Section
  ad: {
    title: "اعتماد کے ساتھ عالمی سطح پر پھیلائیں",
    startNow: "ابھی شروع کریں"
  },

  // Statistics Section
  statistics: {
    title: "ہماری کامیابیاں",
    subtitle: "اعداد جو ہماری کامیابی کی بات کرتے ہیں",
    clients: "خوش گاہک",
    experience: "سالوں کا تجربہ",
    partners: "قابل اعتماد شراکت دار"
  }
}; 